import type { NavigationGuard, RouteLocationNormalized } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions';

const { can, canAny } = usePermissions();

export const permissionGuard: NavigationGuard = (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
) => {
  const permission = to.meta?.permission;

  if (permission === null || permission === undefined || (Array.isArray(permission) && permission.length === 0)) {
    return true;
  }

  const permissionToCheck = permission ?? ''; // Default to an empty string if permission is undefined

  if (Array.isArray(permissionToCheck)) {
    if (canAny(permissionToCheck)) {
      return true;
    }
  }
  else if (can(permissionToCheck)) {
    return true;
  }

  return { path: 'unauthorized' };
};
